import React from 'react';
import Pill from "../../../../gd-components/molecules/pill/pill";

type Props = {
    size?           : '26' | '22'
    option          : Option
    className?      : string
    style?          : style

    disabled?       : boolean

    onClick?        : callback
    onDelete?       : callback

}

export default function FieldMultiselect_Pill(props:Props) {

    if (!props.option) return null;

    const onClick = (e: React.MouseEvent) => {
        if(props.onClick) props.onClick(props.option, e);
    }

    const onDelete = (e: React.MouseEvent) => {
        if(props.onDelete) props.onDelete(props.option, e);
    }

    const optionColor = _.get(props.option, 'color', null);

    const size = _.get(props, 'size', '26')

    if (optionColor) {
        return <Pill size       = {size}
                     icon       = {props.option.icon}
                     label      = {props.option.label}
                     palette    = "project"
                     style      = {props.style}
                     disabled   = {props.disabled}
                     onDelete   = {onDelete}
                     onClick    = {onClick}     // yes need to check other wise click wont go through
                     color      = {optionColor}
                     className  = {props.className}
        />
    } else {
        return <Pill size       = {size}
                     icon       = {props.option.icon}
                     label      = {props.option.label}
                     palette    = "gray"
                     style      = {props.style}
                     disabled   = {props.disabled}
                     onDelete   = {onDelete}
                     onClick    = {onClick}     // yes need to check other wise click wont go through
                     className  = {props.className}

        />
    }

}
